import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import TrueImpactText from '../../../design-system/base/TrueImpactText';
import { SPACERS } from '../../../design-system/settings/variables/Spacers';
import IntroSteps from './IntroSteps';
import TrueImpactButton from '../../../design-system/components/TrueImpactButton';
import { scrollToBottom } from '../../../utils/pageUtils';
import { IntroProps } from './utils';
import TrueImpactAnimation from '../../../design-system/base/TrueImpactAnimation';
import Share from 'shared/statics/illo_share_report.png';
import DownloadReportQuestions from '../../DownloadReportQuestions';

type IntroReportingProps = IntroProps

const StyledDiv = styled.div`
  padding-bottom: 1000px;
  height: 100vh;
  background: rgb(217, 234, 241);
  background: linear-gradient(
    180deg,
    rgba(217, 234, 241, 1) 0%,
    rgba(255, 255, 255, 1) 20%
  );
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${SPACERS.extraLarge};
  .intro-heading {
    text-align: center;
    margin-top: ${SPACERS.large};
    margin-bottom: ${SPACERS.small};
    .heading-normal {
      font-weight: normal !important;
    }
  }
  .intro-help {
    margin-bottom: ${SPACERS.extraLarge};
  }
  .intro-wrapper {
    display: flex;
    justify-content: center;
    gap: ${SPACERS.extraLarge};
    margin-bottom: ${SPACERS.large};
    .file-icon-wrapper {
      width: 840px;
      .icon-shadow {
        margin-bottom: ${SPACERS.extraLarge};
      }
    }
  }
  .share-report {
    display: flex;
    justify-content: center;
    padding-left: 50px;
    img {
      width: 260px;
    }
    .share-text {
      max-width: 400px;
      margin-left: -50px;
    }
  }
  .get-started-button-wrapper {
    margin-top: ${SPACERS.medium};
    .get-started-button {
      margin-left: auto;
      margin-right: auto;
    }
  }
  .download-report-questions {
    text-align: center;
    margin-top: ${SPACERS.small};
  }
`;

const currentYear = new Date().getFullYear();
const IntroReporting: React.FC<IntroReportingProps> = ({
  reportYear,
  handleClose,
}) => {
  const [steps, setSteps] = useState<number>(1);
  const year = reportYear ? Number(reportYear) : currentYear;

  const handleNext = useCallback(() => {
    setSteps(s => s + 1);
  }, [setSteps]);

  const isLastStep = steps > 3;
  useEffect(() => {
    if (isLastStep) {
      scrollToBottom();
    }
  }, [steps]);

  return (
    <StyledDiv>
      <TrueImpactText variant="heading-page" className="intro-heading">
        Reporting with True Impact:{' '}
        <span className="heading-normal">How it works</span>
      </TrueImpactText>
      <TrueImpactText
        variant="body-large"
        align="center"
        className="intro-help"
      >
        You Set it and Update It (2x/year) — We Share It
      </TrueImpactText>
      <div className="intro-wrapper">
        <div>
          <IntroSteps reportYear={reportYear || String(currentYear)} />
        </div>
      </div>
      <TrueImpactAnimation animationDelay={2.5}>
        <div className="share-report">
          <img src={Share} />
          <TrueImpactText variant="body" className="share-text">
            Designated donors automatically receive copies of your annual social
            impact report and real-time updates.
          </TrueImpactText>
        </div>
      </TrueImpactAnimation>
      <DownloadReportQuestions
        isButton={false}
        text="Download a preview of the questions"
        className="download-report-questions"
      />
      <TrueImpactAnimation animationDelay={3}>
        <div className={'get-started-button-wrapper'}>
          <TrueImpactButton
            className="get-started-button"
            onClick={handleClose}
          >
            Get started
          </TrueImpactButton>
        </div>
      </TrueImpactAnimation>
    </StyledDiv>
  );
};

export default IntroReporting;
